export function defineSitemap(_routes, sitemap) {
    return sitemap;
}
//# sourceMappingURL=sitemap.js.map